import { createNamespace } from "Common/namespaceUtils/namespaceRedux";
export const NAMESPACE = "popupMessages";
export const FULL_NAMESPACE = createNamespace(NAMESPACE);
